import React from 'react'

function MultuplexOutlet() {
  return (
    <embed src="\pdfs\EAT1.2.1.1_FA-V_Multiplex_outlet_kr (1).pdf" width="100%" height="2100px" />
  )
}

export default MultuplexOutlet